export const isValidFileSize = (size: number, file?: Blob): boolean =>
  (file?.size ?? 0) <= size * 1_000_000;

export const isValidFileType = (types: Array<string>, file?: Blob): boolean =>
  types.includes(file?.type ?? "");
